module.exports = __webpack_public_path__ + "img/background.b85dcaa3.jpg";